import Loader from 'components/Loader'
import React, { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'

const BussinesSmart = lazy(async ()=>import('./bussinesSmart'))
const Analitica = ({ match }: any) => {
    

  return (
    <div className="app-wrapper">
      <Switch>
        <Suspense fallback={<Loader />}>
          <Route path={`${match.url}/inteligencia-negocio`} component={BussinesSmart} />
        </Suspense>
      </Switch>
    </div>
  )
}

export default Analitica
